import * as React from 'react';
import { IPhotosTab } from './interfaces';
import { PhotoGallery } from '../../../../../../components/PhotoGallery';

export const PhotosTab: React.FC<IPhotosTab> = ({
  show,
  photos,
}): JSX.Element | null => {
  if (!show) {
    return null;
  }

  return <PhotoGallery photos={photos} />;
};
